<template>
  <!-- 用户手册 操作手册 -->
  <div>
    <div id="usermaunal">
      <van-divider
        content-position="left"
        :style="{ fontSize: '16px', margin: '10px 0px' }"
        >一.示意图(点击小图,查阅大图)</van-divider
      >
      <van-divider content-position="left" :style="{ margin: '10px 0px' }"
        >1.主屏示意图</van-divider
      >
      <van-grid :border="false" :column-num="4">
        <van-grid-item
          v-for="(item, index) in listData"
          v-show="item"
          :key="index"
        >
          <van-image :src="item" @click="getImg(listData, index)" />
          <span>主屏示意图{{ index + 1 }}</span>
          <!-- <span>主屏示意图{{ ["一", "二", "三", "四", "五", "六", "七"][index] }}</span> -->
        </van-grid-item>
      </van-grid>
      <van-divider
        content-position="left"
        :style="{ fontSize: '16px', margin: '20px 0px' }"
        >2.搜索引擎检索结果示意图</van-divider
      >
      <van-divider content-position="left" :style="{ margin: '10px 0px' }"
        >2.1.综合检索</van-divider
      >
      <van-grid :border="false" :column-num="4">
        <van-grid-item
          v-for="(item, index) in listData1"
          v-show="item"
          :key="index"
        >
          <van-image :src="item" @click="getImg1(listData1, index)" />
          <span>综合检索{{ index + 1 }}</span>
          <!-- <span>综合检索{{ ["一", "二", "三", "四"][index] }}</span> -->
        </van-grid-item>
      </van-grid>
      <van-divider content-position="left" :style="{ margin: '10px 0px' }"
        >2.2.行业检索</van-divider
      >
      <van-grid :border="false" :column-num="4">
        <van-grid-item
          v-for="(item, index) in listData2"
          v-show="item"
          :key="index"
        >
          <van-image :src="item" @click="getImg2(listData2, index)" />
          <span>行业检索{{ index + 1 }}</span>
          <!-- <span>行业检索{{ ["一", "二", "三"][index] }}</span> -->
        </van-grid-item>
      </van-grid>
      <van-divider content-position="left" :style="{ margin: '10px 0px' }"
        >2.3.税收优惠检索</van-divider
      >
      <van-grid :border="false" :column-num="4">
        <van-grid-item
          v-for="(item, index) in listData3"
          v-show="item"
          :key="index"
        >
          <van-image :src="item" @click="getImg3(listData3, index)" />
          <span>税收优惠检索{{ index + 1 }}</span>
          <!-- <span>税收优惠检索{{ ["一", "二"][index] }}</span> -->
        </van-grid-item>
      </van-grid>
      <van-divider content-position="left" :style="{ margin: '10px 0px' }"
        >2.4.条约检索</van-divider
      >
      <van-grid :border="false" :column-num="4">
        <van-grid-item
          v-for="(item, index) in listData4"
          v-show="item"
          :key="index"
        >
          <van-image :src="item" @click="getImg4(listData4, index)" />
          <span>条约检索{{ index + 1 }}</span>
          <!-- <span>条约检索{{ ["一", "二", "三"][index] }}</span> -->
        </van-grid-item>
      </van-grid>
      <van-divider content-position="left" :style="{ margin: '10px 0px' }"
        >2.5.进出口税收检索</van-divider
      >
      <van-grid :border="false" :column-num="4">
        <van-grid-item
          v-for="(item, index) in listData5"
          v-show="item"
          :key="index"
        >
          <van-image :src="item" @click="getImg5(listData5, index)" />
          <span>进出口检索{{ index + 1 }}</span>
          <!-- <span>进出口检索{{ ["一", "二"][index] }}</span> -->
        </van-grid-item>
      </van-grid>
      <van-divider
        content-position="left"
        :style="{ fontSize: '16px', margin: '20px 0px' }"
        >3.检索结果一键上传与选择上传示意图</van-divider
      >
      <van-divider content-position="left" :style="{ margin: '10px 0px' }"
        >3.1.一键上传</van-divider
      >
      <van-grid :border="false" :column-num="4">
        <van-grid-item
          v-for="(item, index) in listData6"
          v-show="item"
          :key="index"
        >
          <van-image :src="item" @click="getImg6(listData6, index)" />
          <span>一键上传{{ index + 1 }}</span>
          <!-- <span>一键上传{{ ["一", "二", "三", "四", "五", "六"][index] }}</span> -->
        </van-grid-item>
      </van-grid>
      <van-divider content-position="left" :style="{ margin: '10px 0px' }"
        >3.2.选择上传</van-divider
      >
      <van-grid :border="false" :column-num="4">
        <van-grid-item
          v-for="(item, index) in listData7"
          v-show="item"
          :key="index"
        >
          <van-image :src="item" @click="getImg7(listData7, index)" />
          <span>选择上传{{ index + 1 }}</span>
          <!-- <span>选择上传{{ ["一", "二", "三", "四", "五", "六"][index] }}</span> -->
        </van-grid-item>
      </van-grid>
      <van-divider
        content-position="left"
        :style="{ fontSize: '16px', margin: '20px 0px' }"
        >4.智慧云端示意图</van-divider
      >
      <van-grid :border="false" :column-num="4">
        <van-grid-item
          v-for="(item, index) in listData8"
          v-show="item"
          :key="index"
        >
          <van-image :src="item" @click="getImg8(listData8, index)" />
          <span>云端示意图{{ index + 1 }}</span>
          <!-- <span>云端示意图{{ ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "11", "12"][index] }}</span> -->
        </van-grid-item>
      </van-grid>
      <van-divider
        content-position="left"
        :style="{ fontSize: '16px', margin: '20px 0px' }"
        >5.具体文件示意图</van-divider
      >
      <van-grid :border="false" :column-num="4">
        <van-grid-item
          v-for="(item, index) in listData9"
          v-show="item"
          :key="index"
        >
          <van-image :src="item" @click="getImg9(listData9, index)" />
          <span>文件示意图{{ index + 1 }}</span>
          <!-- <span>文件示意图{{ ["一", "二", "三", "四", "五", "六"][index] }}</span> -->
        </van-grid-item>
      </van-grid>
      <div class="word">
        <!-- <h3>二、专有名词解释</h3> -->
        <van-divider
          content-position="left"
          :style="{ fontSize: '16px', margin: '20px 0px' }"
          >二、专有名词解释</van-divider
        >
        <h5>1.特定适用对象:</h5>

        <p>归集文件条款含有针对特定对象制发的内容，包括7个二级分类。</p>

        <h5>2.行业类之二级分类“通用规定”:</h5>

        <p>归集文件条款含有针对所有行业制发的内容。</p>

        <h5>3.行业类之二级分类“专属规定”：</h5>

        <p>归集文件条款含有针对特定行业制发的内容。</p>

        <h5>4.税收条约之二级分类“通用规定”：</h5>

        <p>归集文件条款含有针对所有缔约国家（地区）制发的内容。</p>

        <h5>5.税收条约之二级分类“国家（地区）”：</h5>

        <p>归集文件条款含有针对特定缔约国家（地区）制发的内容。</p>

        <h5>6.税收条约具体文件中的特别处理：</h5>

        <p>
          6.1.文件名中的“红色括号标注内容”：为便于用户迅速了解文件的签订年度，缔约国家的解体、建国以及相关的延续适用等对文件的适用影响，相应添加。
        </p>
        <p>
          6.2.部分议定书、换文和换函等的适用基础、适用对象等对用户适用文件有重要支撑，相应添加（红色字体）。
        </p>
        <p>
          6.3.文件末尾添加的“相关链接”：为便于用户迅速了解文件制发的相关过程，准确适用文件。
        </p>
        <h5>7.具体文件中的“版本汇总”及“年份标注”：</h5>

        <p>
          7.1.版本汇总：针对部门规章及以上的文件，存在若干次修订的情况下，因文件名相同，为便于用户准确适用，在文件名处添加“红色括号标注版本”，并在文件名之下以三段或两段文字论述最新版本及当前版本变动成因和“版本汇总”链接点，文件末尾设“版本汇总”归集所有版本，首尾呼应；
        </p>
        <p>
          7.2.年份标注：针对非版本汇总文件，因若干次修改，出现同名情形，在文件名处添加“红色括号标注年份”。
        </p>
        <h5>8.税法应用智能化模块：</h5>

        <p>
          由法规层级筛选框和法规分类筛选框组成，用于对相应文件列表内的文件进行精准查询。辅之以“检索结果一键上传”和“检索结果选择上传”，用于对选中文件上传至智慧云端之“上传文件库”。
        </p>

        <h5>9.智慧云端：</h5>

        <p>
          暂开放“上传文件库”，用户可在云端文件库管理和适用文件，实现“一次上传，多口径切换选取适用文件”。
        </p>

        <h5>10.创设文号：</h5>

        <p>
          具体文件为附件或政策解读时，页首要素中的文号设计，用于迅速链接主文件。
        </p>

        <!-- <h3>三、特别指引</h3> -->
        <!-- <van-divider content-position="left" :style="{ fontSize: '16px', margin: '20px 0px' }">三、特别指引</van-divider>
      <p>1.点击文件分类树选项，最新文件列表相应匹配响应，税法应用智能化模块相应锁定；若用户之前已经启动搜索引擎获取检索结果，点击文件分类树选项会重置刷新搜索引擎。</p>

      <p>2.最新文件列表与检索结果列表可同时存在，独立操作，可以点击相应名称栏目条隐藏与展开。</p>

      <p>3.在最新文件列表、检索结果列表或上传文件列表中点击时间选择框或关键字再次检索框，选择特定时间区域或输入特定关键字，将对列表内文件再次精准匹配，可多次使用。</p>

      <p>4.在初始进入状态下的最新文件列表（即未点击文件分类树的情形下）、检索结果列表或上传文件列表中，点击税法应用智能化模块，根据需要选择，可多次切换列表文件得到相应结果；并可与列表中时间选择框或关键字再次检索框搭档使用，更加智能便捷。</p>

      <p>5.点击多个文件形成电脑屏幕分屏呈现多个文件，当前电脑屏幕最多呈现三屏文件，其余屏隐藏，可通过滚动条拖动相关文件屏；亦可以通过蓝色缩放按钮实现相关区域隐藏与展示操作。</p>

      <p>6.单个文件、最新文件列表文件或检索结果列表文件均支持上传云端。</p>

      <p>7.具体文件内蓝色字体文件均已建立链接。</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
export default {
  data() {
    return {
      show: false,
      index: 0,
      listData: [
        require("../../assets/usermaunal/1.png"),
        require("../../assets/usermaunal/2.png"),
        require("../../assets/usermaunal/3.png"),
        require("../../assets/usermaunal/48.png"),
        require("../../assets/usermaunal/50.png"),
        require("../../assets/usermaunal/51.png"),
        require("../../assets/usermaunal/49.png"),
      ],
      listData1: [
        // 综合检索
        require("../../assets/usermaunal/4.png"),
        require("../../assets/usermaunal/5.png"),
        require("../../assets/usermaunal/6.png"),
        require("../../assets/usermaunal/11.png"),
      ],
      listData2: [
        // 行业检索
        require("../../assets/usermaunal/7.png"),
        require("../../assets/usermaunal/12.png"),
        require("../../assets/usermaunal/13.png"),
      ],
      listData3: [
        // 税收优惠检索
        require("../../assets/usermaunal/10.png"),
        require("../../assets/usermaunal/14.png"),
      ],
      listData4: [
        // 条约检索
        require("../../assets/usermaunal/8.png"),
        require("../../assets/usermaunal/15.png"),
        require("../../assets/usermaunal/16.png"),
      ],
      listData5: [
        // 进出口税收检索
        require("../../assets/usermaunal/9.png"),
        require("../../assets/usermaunal/17.png"),
      ],
      listData6: [
        // 一键上传
        require("../../assets/usermaunal/18.png"),
        require("../../assets/usermaunal/19.png"),
        require("../../assets/usermaunal/20.png"),
        require("../../assets/usermaunal/21.png"),
        require("../../assets/usermaunal/22.png"),
        require("../../assets/usermaunal/23.png"),
      ],
      listData7: [
        // 选择上传
        require("../../assets/usermaunal/24.png"),
        require("../../assets/usermaunal/25.png"),
        require("../../assets/usermaunal/26.png"),
        require("../../assets/usermaunal/27.png"),
        require("../../assets/usermaunal/22.png"),
        require("../../assets/usermaunal/28.png"),
      ],
      listData8: [
        // 智慧云端
        require("../../assets/usermaunal/41.png"),
        require("../../assets/usermaunal/30.png"),
        require("../../assets/usermaunal/31.png"),
        require("../../assets/usermaunal/32.png"),
        require("../../assets/usermaunal/33.png"),
        require("../../assets/usermaunal/34.png"),
        require("../../assets/usermaunal/35.png"),
        require("../../assets/usermaunal/36.png"),
        require("../../assets/usermaunal/37.png"),
        require("../../assets/usermaunal/38.png"),
        require("../../assets/usermaunal/39.png"),
        require("../../assets/usermaunal/40.png"),
      ],
      listData9: [
        // 文件
        require("../../assets/usermaunal/42.png"),
        require("../../assets/usermaunal/43.png"),
        require("../../assets/usermaunal/44.png"),
        require("../../assets/usermaunal/45.png"),
        require("../../assets/usermaunal/46.png"),
        require("../../assets/usermaunal/47.png"),
      ],
      imgurl: "",
    };
  },
  components: {},
  methods: {
    getImg(images, index) {
      ImagePreview({
        images: this.listData,
        showIndex: true,
        loop: false,
        startPosition: index,
        closeable: false,
      });
    },
    getImg1(images, index) {
      ImagePreview({
        images: this.listData1,
        showIndex: true,
        loop: false,
        startPosition: index,
        closeable: false,
      });
    },
    getImg2(images, index) {
      ImagePreview({
        images: this.listData2,
        showIndex: true,
        loop: false,
        startPosition: index,
        closeable: false,
      });
    },
    getImg3(images, index) {
      ImagePreview({
        images: this.listData3,
        showIndex: true,
        loop: false,
        startPosition: index,
        closeable: false,
      });
    },
    getImg4(images, index) {
      ImagePreview({
        images: this.listData4,
        showIndex: true,
        loop: false,
        startPosition: index,
        closeable: false,
      });
    },
    getImg5(images, index) {
      ImagePreview({
        images: this.listData5,
        showIndex: true,
        loop: false,
        startPosition: index,
        closeable: false,
      });
    },
    getImg6(images, index) {
      ImagePreview({
        images: this.listData6,
        showIndex: true,
        loop: false,
        startPosition: index,
        closeable: false,
      });
    },
    getImg7(images, index) {
      ImagePreview({
        images: this.listData7,
        showIndex: true,
        loop: false,
        startPosition: index,
        closeable: false,
      });
    },
    getImg8(images, index) {
      ImagePreview({
        images: this.listData8,
        showIndex: true,
        loop: false,
        startPosition: index,
        closeable: false,
      });
    },
    getImg9(images, index) {
      ImagePreview({
        images: this.listData9,
        showIndex: true,
        loop: false,
        startPosition: index,
        closeable: false,
      });
    },
  },
};
</script>

<style lang="less" scoped>
#usermaunal {
  padding: 0 10px 10px;
  box-sizing: border-box;
  h3 {
    font-size: 14px;
    font-weight: bold;
  }
  span {
    margin-top: 4px;
    font-size: 10px;
  }
  /deep/.van-grid {
    background: #fff;
  }
  .word {
    font-size: 14px;
    line-height: 26px;
    h5 {
      margin: 0;
      font-size: 14px;
    }
    p {
      text-indent: 20px;
    }
  }
  /deep/.van-divider--content-left::before {
    max-width: 4%;
  }
}
</style>
<style>
.van-image__img {
  width: 92%;
  margin: auto;
}
</style>
